import template from './wageAdvanceModal.html';
import controller from './wageAdvanceModal.controller';
import './wageAdvanceModal.scss';

let wageAdvanceModalComponent = {
  restrict: 'E',
  bindings: {
    modalToShow: '<',
    messageError: '<',
    closeModal: '&',
    cancelWageAdvance: '&',
    isMobileApp: '<'
  },
  template,
  controller,
};

export default wageAdvanceModalComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceModal/wageAdvanceModal.component.js